import { render, staticRenderFns } from "./CallsIncomingAttended.vue?vue&type=template&id=46b58758&"
import script from "./CallsIncomingAttended.vue?vue&type=script&lang=js&"
export * from "./CallsIncomingAttended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports